import React, { useState, useEffect } from 'react';
import { Mic, MessageCircle, Users, Briefcase, Heart } from 'lucide-react';
import { useInView } from 'react-intersection-observer';
import './TrackingSection.css';

function TrackingSection() {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true
  });
  
  // Dynamic icon sizing based on screen width
  const [iconSize, setIconSize] = useState(32);
  
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 2899) {
        setIconSize(48);
      } else if (window.innerWidth >= 1920) {
        setIconSize(40);
      } else {
        setIconSize(32);
      }
    };
    
    // Initial call
    handleResize();
    
    // Event listener for window resize
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section className="tracking-section">
      <div className="parallax-bg"></div>
      <div className="content-container">
        <div className={`tracking-content ${inView ? 'animate' : ''}`} ref={ref}>
          <h1>THE BOLDLY ENGLISH PROMISE</h1>
          <div className="description">
            <p>Unlock your true potential with Boldly English. We help you master clear speaking, fearless expression, and professional communication for real-world success.</p>
          </div>

          <div className="feature-items">
            <div className="feature-item">
              <div className="feature-icon">
                <Mic size={iconSize} />
              </div>
              <div className="feature-text">
                <h3>Speak clearly and confidently</h3>
                <p>Enhance pronunciation and clarity while speaking.</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <MessageCircle size={iconSize} />
              </div>
              <div className="feature-text">
                <h3>Express thoughts without fear</h3>
                <p>Overcome hesitation and express yourself freely.</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <Users size={iconSize} />
              </div>
              <div className="feature-text">
                <h3>Communicate fluently in social and professional settings</h3>
                <p>Converse smoothly in meetings, gatherings, and daily life.</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <Briefcase size={iconSize} />
              </div>
              <div className="feature-text">
                <h3>Be interview-ready</h3>
                <p>Prepare to ace interviews with strong communication skills.</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <Heart size={iconSize} />
              </div>
              <div className="feature-text">
                <h3>Gain lifelong self-belief</h3>
                <p>Build the confidence to speak and succeed anywhere.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrackingSection;